import SanityClient from '@sanity/client';

export default SanityClient({
  projectId: 'aiszsefb',
  dataset: 'template',
});
